import React from 'react';
import { Box, CircularProgress, CircularProgressProps } from '@mui/material';

export type OverlaySpinnerProps = CircularProgressProps;

const DEFAULT_SIZE = 80;

export function OverlaySpinner({
  size = DEFAULT_SIZE,
  className,
  sx,
  style,
  ...props
}: OverlaySpinnerProps) {
  return (
    <Box
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      className={className}
      style={style}
    >
      <CircularProgress size={size} {...props} />
    </Box>
  );
}
